import * as React from 'react';
import { UilInfoCircle } from '@iconscout/react-unicons';
import { ALERT_MESSAGE_TYPES } from '../../../interface/project.interface';
export interface INotesProps {
    note?: string;
    type?: ALERT_MESSAGE_TYPES;
    children?: React.ReactChild;
}

const Notes: React.SFC<INotesProps> = ({
    note = 'Placeholder',
    type = ALERT_MESSAGE_TYPES.INFO,
    children
}) => (
    <div className={`note-container note-container--${type}`}>
        {children ? (
            <div>{children}</div>
        ) : (
            <div className="note-body">
                <div className="note-icon">
                    <UilInfoCircle size={18} />
                </div>
                <div>
                    <div className="note-title">Note</div>
                    <div className="note-content">{note}</div>
                </div>
            </div>
        )}
    </div>
);

export default Notes;
